var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrowBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 19,
    viewBox: "0 0 12 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8135 0.365889C10.5882 0.123051 10.2821 0.000167774 9.97504 0.000232597C9.69662 0.000232572 9.4175 0.10132 9.19735 0.305591L0.365677 8.50189C0.132495 8.7183 -4.39784e-05 9.02207 -4.40062e-05 9.3402C-4.4034e-05 9.65833 0.132495 9.9621 0.365677 10.1785L9.19735 18.3748C9.66015 18.8044 10.384 18.7775 10.8136 18.3145C11.2433 17.8515 11.2163 17.1279 10.7533 16.6983L2.82488 9.3402L10.7532 1.98221C11.2162 1.55251 11.2432 0.828884 10.8135 0.365889Z",
    fill: "#002651"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrowBlue);
export default __webpack_public_path__ + "static/media/back-arrow-blue.358046105f96f8bacf4c4f195660b3b5.svg";
export { ForwardRef as ReactComponent };